import React, { useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import Button from "../../components/CustomButtons/Button.js";
import Card from "../../components/Card/Card.js";
import CardFooter from "../../components/Card/CardFooter.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import { useHistory } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { uploadFile } from "../../api/rankingApi";
import { showWarningToast } from "../../utils/toastMessages";
import { CircularProgress } from "@material-ui/core";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
  button: {
    flexDirection: 'row',
    justify: 'center',
    align: 'center',
    justifyContent: 'center'
  },
  loaderDescription: {
    margin: "2px"
  }
};

const useStyles = makeStyles(styles);

export default function ImportData() {
  const history = useHistory(); // Initialize useHistory hook

  const classes = useStyles();

  const [file, setFile] = useState(null);

  const [isLoading, setIsLoading] = useState(false); 

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const goToResults = (response) => {
    history.push("/admin/results", {
      matrix: response.matrix,
      rankedAlternatives: response.results,
      alternativesNames: response.alternativesNames,
      criteriaSelected: response?.criteria?.map((criterion) => criterion?.id),
    });
  };

  const handleUpload = async () => {
    if (file) {
      const formData = new FormData();
      formData.append("file", file);

      setIsLoading(true); 

      try {
        const response = await uploadFile(formData);
        goToResults(response);
      } catch (error) {
        showWarningToast({
          title: error.response.data,
          message: "Obratiti pažnju na format fajla!",
        });
        console.error("Greška pri učitavanju fajla", error);
      } finally {
        setIsLoading(false); 
      }
    }
    else
      showWarningToast({
        title: "Greška!",
        message: "Niste izabrali ispravan fajl. Pokušajte ponovo.",
      });
  };

  const handleTemplateDownload = () => {
    const link = document.createElement("a");
    link.href = "/FRUITrank_template.xlsx";
    link.download = "FRUITrank_template.xlsx";
    link.click();
  };

  return (
    <>
      <ToastContainer />
      <div>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>
            <Card>
              <CardHeader color="success">
                <h4 className={classes.cardTitleWhite}>Import podataka</h4>
              </CardHeader>
              <CardBody>
                <h3>Upozorenje o formatu .xlsx fajla</h3>
                <p>
                  U prvoj koloni treba da se nalaze nazivi alternativa (možete
                  imati koliko god želite alternativa).
                </p>
                <p>
                  U prvom redu, počevši od druge kolone, treba da se nalaze
                  oznake kriterijuma (za oznake kriterijuma možete pogledati{" "}
                  <a href="/admin/showallcriteria">Informacije o kriterijuma</a>
                  )
                </p>
                <p>
                  Dostupan vam je i primjerak fajla{" "}
                  <Button color="info" onPress={handleTemplateDownload}>
                    Preuzmite primjerak
                  </Button>
                </p>
                <br />
                <input
                  id="fajl"
                  onChange={handleFileChange}
                  type="file"
                  accept=".xlsx"
                />
              </CardBody>
              <CardFooter className={classes.centerElement}>
                <Button color="success" onPress={handleUpload} disabled={isLoading}>
                  {isLoading ? (
                    <CircularProgress size={20} color="inherit" style={{width: "120px"}}/>
                  ) : (
                    "Pošalji na obradu"
                  )}
                </Button>
                {isLoading && <div className={classes.loaderDescription}> Obrada podataka u toku...</div>}
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    </>
  );
}

